import { CurrentUserGq, CurrentUserGqProps } from '../models/CurrentUserGq';
import { useMutation } from '@apollo/client';
import gql from 'graphql-tag';
import { useCallback } from 'react';
import { UserTeamRoleGq } from '../models/UserTeamRoleGq';
import { PublicUserGq } from '../models/PublicUserGq';

export default function useInviteUserGq() {
  const [mutation, mutationResult] = useMutation<ResponseGq, VariablesGq>(gqTag);

  return useCallback(
    (command: CommandGq) =>
      mutation({ variables: { command } }).then((result) => result.data.users.inviteUser.user),
    []
  );
}

const gqTag = gql`
  mutation InviteUser($command: InviteUserCommand!) {
    users {
      inviteUser(command: $command) {
        user { ${CurrentUserGqProps} }
      }
    }
  }
`;

interface VariablesGq {
  command: CommandGq;
}

export interface CommandGq {
  email: string;
  role: UserTeamRoleGq;
}

interface ResponseGq {
  users: {
    inviteUser: {
      user: PublicUserGq;
    };
  };
}
